import { useMediaQuery } from 'react-responsive';

const useMedia = () => {
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  return [isMobile];
};

export default useMedia;
